 @for (sidecarApp of framableApps$ | async; track sidecarApp.app) {
  <div [hidden]="!isVisible()" class="iframe-overlay-container" [style.width]="width" [style.height]="height">
    <iframe id="{{sidecarApp.app}}" class="iframe-overlay"
      [src]="sidecarApp.url | safe"
      [attr.aria-label]="sidecarApp.app"
      [attr.data-app]="sidecarApp.app"
      (error)="onError(sidecarApp)"
      scrolling="no"
      allow="fullscreen"
      allowfullscreen>
    </iframe>
  </div>
}
